// Core
import React, { FC } from 'react';
import { createPortal } from 'react-dom';
// Parts
import Table, { TableApiParamsType, TableHashCacheType } from "../../../components/Table";
// Engine
import { axiosAPI } from "../../../../engine/config/axios";

const SsoGroups:FC<TableHashCacheType> = (props) => {
  const { hashCache } = props;

  const gridParams = {
    grids: [{ name: 'sso_groups', hashCache }],
  }

  const apiParams: TableApiParamsType = (loadOptions, pageParams) => ({
      filters: loadOptions?.filter,
      sort: loadOptions?.sort,
      ...pageParams
    });

  return <Table
    keyExpr="id"
    api={axiosAPI.settings.ssoGroups.table}
    apiParams={apiParams}
    gridParams={gridParams}
    gridName="sso_groups"
    sortingMode="multiple"
  />;
}

function SsoGroupsPortal({ id }: { id: string }) {
  const Root = document.getElementById(id);
  return Root ? createPortal(<SsoGroups hashCache={Root?.dataset.hashCache} />, Root) : null;
}

export default SsoGroupsPortal;
